<template>
  <div class="evaluation-item">
    <div class="evaluation-item-user">
      <img :src="item.userHeadshot" />
      <div>
        <b>{{ item.userNickName }}</b>
        <span>{{ item.commodityServiceSpecs }}</span>
      </div>
    </div>
    <div :class="['evaluation-item-text', fromGoodsDetail && _._ellipsis2]">
      {{ item.evaluateContent }}
    </div>
    <div
      :class="{
        'evaluation-item-img': true,
        'style-2': !fromGoodsDetail && [1, 2].includes(item.evaluatePic.length),
        'max-4': fromGoodsDetail,
      }"
    >
      <img
        v-for="(url, index) in fromGoodsDetail
          ? item.evaluatePic.slice(0, 4)
          : item.evaluatePic"
        :key="index"
        :src="url"
        @click="handleImageClick(item.evaluatePic, index)"
      />
    </div>
    <div
      v-if="item.evaluateAddContent || item.evaluateAddPic.length"
      class="evaluation-item-add"
    >
      <div class="title">用户追评</div>
      <span>{{ item.evaluateAddContent }}</span>

      <div
        :class="{
          'evaluation-item-img': true,
          'style-2':
            !fromGoodsDetail && [1, 2].includes(item.evaluateAddPic.length),
          'max-4': fromGoodsDetail,
        }"
      >
        <img
          v-for="(url, index) in fromGoodsDetail
            ? item.evaluateAddPic.slice(0, 4)
            : item.evaluateAddPic"
          :key="index"
          :src="url"
          @click="handleImageClick(item.evaluateAddPic, index)"
        />
      </div>
    </div>
    <div v-if="item.replyContent" class="evaluation-item-reply">
      <div>商家回复</div>
      <span>{{ item.replyContent }}</span>
    </div>
    <div class="evaluation-item-date">
      <span>{{ date }}</span>
      <div class="flex-auto"></div>
      <img
        v-if="item.thumbsUpFlag"
        src="https://app-frontend.oss-cn-hangzhou.aliyuncs.com/duoduo-mall/img/commodity/approval2.png"
        @click="thumbsUpOrDown"
      />
      <img
        v-else
        src="https://app-frontend.oss-cn-hangzhou.aliyuncs.com/duoduo-mall/img/commodity/approval.png"
        @click="thumbsUpOrDown"
      />
      <a @click="thumbsUpOrDown">{{ item.thumbsUpCount }}</a>
    </div>
  </div>
</template>

<script>
  import { apiEvaluationEvaluateThumbsUpOrDown } from '@/api'
  import { ImagePreview } from 'vant'

  export default {
    props: {
      item: {
        type: Object,
        default: () => Object,
      },
      fromGoodsDetail: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      date() {
        const date = new Date()
        const end = new Date(this.item.createTime.replace(/-/g, '/'))
        const delta = (date - end) / 1000 / 60
        if (delta < 1) {
          return '刚刚'
        } else if (delta < 60) {
          return `${Math.round(delta)}分钟前`
        }
        const tmp = new Date()
        tmp.setDate(tmp.getDate() - 1)
        if (
          tmp.getFullYear() === end.getFullYear() &&
          tmp.getMonth() === end.getMonth() &&
          tmp.getDate() === end.getDate()
        ) {
          return `昨天${String(end.getHours()).padStart(2, '0')}:${String(
            end.getMinutes(),
          ).padStart(2, '0')}`
        } else if (date.getFullYear() === end.getFullYear()) {
          return `${String(end.getMonth() + 1).padStart(2, '0')}月${String(
            end.getDate(),
          ).padStart(2, '0')}日`
        }
        return `${String(end.getFullYear()).padStart(2, '0')}年${String(
          end.getMonth() + 1,
        ).padStart(2, '0')}月${String(end.getDate()).padStart(2, '0')}日`
      },
    },
    methods: {
      async thumbsUpOrDown() {
        await apiEvaluationEvaluateThumbsUpOrDown({ id: this.item.id })

        if (!this.item.thumbsUpFlag) {
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpFlag = 1
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpCount++
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpFlag = 0
          // eslint-disable-next-line vue/no-mutating-props
          this.item.thumbsUpCount--
          if (this.item.thumbsUpCount < 0) {
            // eslint-disable-next-line vue/no-mutating-props
            this.item.thumbsUpCount = 0
          }
        }

        this.$forceUpdate()
        // this.goto({contentId: this.item.id, contentName: '取消点赞'})
      },

      handleImageClick(list, index) {
        ImagePreview({
          images: list,
          startPosition: index,
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .evaluation-item {
    &-user {
      display: flex;
      align-items: center;
      margin-top: 21px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
        object-fit: cover;
      }

      b {
        display: block;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      span {
        display: block;
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #bebebe;
        line-height: 12px;
        margin-top: 4px;
      }
    }

    &-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 20px;
      margin-top: 12px;
    }

    &-img {
      display: flex;
      flex-wrap: wrap;
      margin-top: 4px;
      width: calc(100% + 12px);

      img {
        width: 112px;
        height: 112px;
        border-radius: 6px;
        margin-top: 8px;
        margin-right: 7px;
      }
    }

    &-add {
      .title {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff111c;
        line-height: 20px;
        margin-top: 12px;
      }

      span {
        display: block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        margin-top: 8px;
      }
    }

    &-reply {
      background: #f5f6f8;
      border-radius: 8px;
      padding: 12px;
      margin-top: 8px;

      div {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      span {
        display: block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        margin-top: 8px;
      }
    }

    &-date {
      display: flex;
      align-items: center;
      margin-top: 13px;

      .flex-auto {
        flex: auto;
      }

      span {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #bebebe;
        line-height: 12px;
      }

      img {
        width: 14px;
        height: 14px;
      }

      a {
        height: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        line-height: 16px;
        padding-left: 3px;
      }
    }
  }

  ::v-deep {
    .evaluation-item-img {
      img {
        object-fit: cover;
      }
      &.style-2 img {
        width: 172px;
        height: 172px;
      }

      &.max-4 {
        img {
          width: 76px;
          height: 76px;
          margin-right: 8px;
        }
      }
    }
  }
</style>
